/* projects/portal/src/app/pages/catering/catering.component.css */
.pick-field {
  width: 220px;
}
.lead-note {
  font-size: 12px;
  color: var(--ink-muted);
}
.card {
  padding: 18px 18px 8px;
}
.card .toolbar {
  margin-bottom: 4px;
}
.card .table-wrap {
  margin-top: 8px;
}
.prod-name {
  font-weight: 500;
}
.prod-sub {
  font-size: 12px;
  color: var(--ink-muted);
  margin-top: 2px;
}
.prod-tags {
  margin-top: 4px;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.tag {
  font-size: 11px;
  padding: 1px 7px;
  border-radius: 10px;
  background: var(--gray);
  color: var(--ink-muted);
}
.muted {
  color: var(--ink-muted);
}
.qty-col {
  width: 110px;
}
.qty {
  width: 74px;
  padding: 6px 8px;
  text-align: right;
  border: 1px solid var(--line);
  border-radius: 4px;
  font: inherit;
  font-variant-numeric: tabular-nums;
  color: var(--ink);
  background: var(--surface);
}
.qty:focus {
  outline: none;
  border-color: var(--brand, #d98a1f);
}
tr.row-chosen {
  background: #fffaf2;
}
tr.row-warn {
  background: #fbe6e5;
}
tr.row-warn .qty {
  border-color: var(--red);
}
.qty-warn {
  font-size: 11px;
  color: var(--red);
  text-align: right;
  margin-top: 3px;
}
.form-row {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 18px;
}
.desc-field {
  width: 280px;
}
.comment-field {
  flex: 1 1 320px;
  min-width: 260px;
}
.submit-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 4px 0 16px;
  flex-wrap: wrap;
}
.total {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.total-label {
  font-size: 13px;
  color: var(--ink-muted);
}
.total-value {
  font-size: 22px;
  font-weight: 500;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
}
.total-note {
  font-size: 12px;
  color: var(--ink-muted);
}
.products-cell {
  max-width: 320px;
}
@media (max-width: 700px) {
  .pick-field,
  .desc-field {
    width: 100%;
  }
}
/*# sourceMappingURL=catering.component.css.map */
